import { useState } from "react";
import Alert from "../components/ui/Alert";
import { useData } from "../context/dataContext";
import PanelStatusBody from "../components/PanelStatusBody";
import { Container, Box, Grid, Skeleton } from "@mui/material";

function PanelStatus() {
    const { loadData, dataSelect ,resetMaster, resetRouter } = useData()
    const [alert, setAlert] = useState('')

    const handleResetMaster = async () => {
        const result = await resetMaster(dataSelect.IndexData);
        result ? console.log("Solicitud de reinicio del maestro enviada" ) : console.error("No se pudo solicitar el reinicio del maestro");
        return result;
    };

    const handleResetRouter = async () => {
        const result = await resetRouter(dataSelect.IndexData);
        result ? console.log("Solicitud de reinicio eléctrico enviada" ) : console.error("No se pudo solicitar el reinicio eléctrico");
        return result;
    };

    return (
        <>
            {!loadData && dataSelect ? (
                <>
                    {alert !== '' && <Alert stateAlert={alert} closeAlert={() => { setAlert('') }} />}
                    <div className={`w-full h-full flex flex-col gap-8 bg-[#f9f9f9] px-4 py-8 overflow-auto`}>
                        <div className='flex flex-wrap gap-10 w-full h-full justify-around items-center max-[900px]:flex-col max-[900px]:h-fit '>
                            <PanelStatusBody
                                data={dataSelect}
                                onReprobe={(masterId) => { console.log("Reprobing:", masterId); }}
                                onResetMaster={handleResetMaster}
                                onResetRouter={handleResetRouter}
                            />
                        </div>
                    </div>
                </>
            ) : (
                <div className={`w-full h-full flex flex-col gap-8 items-center bg-[#f9f9f9] px-4 py-8 overflow-auto`}>
                    <div className='flex flex-wrap gap-5 w-full h-full justify-around items-center max-[900px]:flex-col max-[900px]:h-fit '>
                        <Container className="flex flex-col gap-8" >
                            <Box>
                                <Skeleton variant="text" width={200} height={40} />
                                <Skeleton variant="rectangular" height={100} sx={{ my: 2, borderRadius: 2 }} />
                                <Grid container spacing={2}>
                                    {Array.from({ length: 3 }).map((_, i) => (
                                        <Grid item xs={12} sm={6} lg={4} key={i}>
                                            <Skeleton variant="rectangular" height={120} sx={{ borderRadius: 2 }} />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                            <Box>
                                <Skeleton variant="text" width={200} height={40} />
                                <Skeleton variant="rectangular" height={100} sx={{ my: 2, borderRadius: 2 }} />
                                <Grid container spacing={2}>
                                    {Array.from({ length: 3 }).map((_, i) => (
                                        <Grid item xs={12} sm={6} lg={4} key={i}>
                                            <Skeleton variant="rectangular" height={120} sx={{ borderRadius: 2 }} />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                        </Container>
                    </div>
                </div>
            )
            }
        </>
    )
}

export default PanelStatus
